<template>
    <div class="grid md:grid-cols-3 gap-8">
        <MyPackageItem
                v-for="(campaign) in campaigns"
                :key="campaign.CampaignId"
                :campaign="campaign"
        ></MyPackageItem>

        
    </div>
    <!-- <div class="flex w-full screen-content" v-if="isLoaded && !isHaveItem">
        <div class="w-full my-auto text-center text-a-brown-9f8273 text-14">No package found</div>
    </div> -->
</template>
<script>

import BKSubscription from '../service/BKSubscription.js'
//componentv
import MyPackageItem from './MyPackageItem.vue'
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: "MyPackageList",
    mixins: [ModalMixin,LocaleMixin],
    components: {
        MyPackageItem,
    },
    emits: ["onLoaded"],
    data: function() {
        return {
            campaigns: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        };
    },
    created: function () {
        
        // this.getList();
        this.init();
    },
    methods: {
        init: function () {
            if (this.$route.query.from == "shoppingcart") {
                setTimeout(() => {
                    this.$emit('onLoaded');
                },500)

                this.modal.successModal.clearModal()
                    .setMsg(this.lbl.subscription.subscription_summary.payment_success)
                    .show();
                this.modal.successModal.onClose(() => {
                    this.getList();
                });

            } else {
                this.getList();
            }
        },
        getList: function() {
            return new Promise((resolve) => {
                this.isLoading = true;
                BKSubscription.apiGetMyPackages().subscribe({
                    next: (res) => {
                        this.campaigns = res.data;
                        console.log(this.campaigns);    
                        this.isHaveItem = this.campaigns.length > 0;
                        this.isLoaded = true;
                        this.isLoading = false;
                        

                        this.$emit('onLoaded');
                        resolve();
                        
                        
                    },
                    error: (err) => {
                        console.log(err);
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.$emit('onLoaded');
                        resolve();
                        
                    }
                });
            });
        }

    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .screen-content {
        min-height: calc(100vh - 310px);
        
        @include min-desktop {
            min-height: calc(100vh - 256px);
        }
    }
</style> 

